<!--
 * @Author: ken yang
 * @Date: 2022-11-28 09:08:35
 * @LastEditTime: 2022-12-19 13:53:27
 * @LastEditors: ken yang
 * @Description: 顶部横向菜单
 * @FilePath: /uexch_admin/src/layout/components/Navbar.vue
-->
<template>
  <Row class="AppNavbar" x="sb">
    <Row>
      <img src="@/image/AppNavbar-logo.webp" class="w-24 m-r-10">
      <span class="label-lg bold">{{ $t('user.bifinanceDl') }}</span>
    </Row>
    <Row>
      <!-- 语言 -->
      <Row class="languag-box h-24 ">
        <Row class="languag-box  h-24   ">
          <el-dropdown
            class="c-title-hover-primary"
            :teleported="true"
            :hide-timeout="200"
            :popper-class="`dropdown-no-arrow -m-l-20`"
          >
            <Row class="m-l-20 language-title pointer font-18 m-r-30" y="c" x="c">
              <IconSvg class="title transition c-t c-hover-primary font-18 m-r-6" name="icon-language" />
              <span class="m-r-4 transition languag-text font-14" :style="{'white-space':'nowrap'}">{{ configStore.languageName }}</span>
            </Row>
            <template #dropdown>
              <el-dropdown-menu class="w-140">
                <el-dropdown-item
                  v-for="languag in configStore.languageMap"
                  :key="languag.value"
                  :class="languag.value == configStore.locale ? 'bg-d' : ''"
                  @click="changeLang(languag)"
                >
                  <Row class="w-100b h-40" x="sb">
                    <span class="m-r-15">{{ languag.label }}</span>
                    <IconSvg v-if="languag.value == configStore.locale" class="font-10 c-primary" name="icon-IconCheck_Menu" />
                  </Row>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </Row>
      </Row>

      <el-dropdown
        id="downloadApp"
        class="c-title-hover-primary"
        :hide-timeout="200"
        :popper-class="`dropdown-no-arrow radius-6 el-popper-box-p-0 -m-l-20`"
        :teleported="true"
      >
        <Row class="w-60 h-40 position-r pointer nickName-box" y="c">
          <Row class="bg-primary w-32 h-32 radius-50b c-white label bold" x="c" y="c">{{ userStore.info?.nickName?.trim().slice(0,1) }}</Row>
          <img src="@/image/down-arrow.webp" class="w-10 h-6 m-l-6">
        </Row>
        <template #dropdown>
          <Column class="w-220">
            <Column class="w-100b p-10 label border-b">
              <Row class="w-100b p-lr-10 h-40" x="sb">
                <span class="c-info">{{ $t('user.nickname') }}</span>
                <span v-if="!isEmpty(userStore.info) && !isEmpty(userStore.info?.nickName)">{{ userStore.info?.nickName }}</span>
                <span v-else>--</span>
              </Row>
              <Row class="w-100b p-lr-10 h-40" x="sb">
                <span class="c-info">{{ $t('user.account') }}</span>
                <span v-if="!isEmpty(userStore.info) && !isEmpty(userStore.info?.email)">{{ $f.hideEmail(userStore.info?.email) }}</span>
                <span v-else>--</span>
              </Row>
              <Row class="w-100b p-lr-10 h-40" x="sb">
                <span class="c-info">UID</span>
                <Row>
                  <span class="label-sm">{{ userStore.info?.uid }}</span>
                  <CopyToClip :size="8" :value="userStore.info?.uid" class="m-l-5 label-sm" />
                </Row>
              </Row>
            </Column>
            <Row class="w-100b h-50 p-lr-20" x="e">
              <el-button class="label" link type="primary" @click="userStore.logout">{{ $t('user.ExitSystem') }}</el-button>
            </Row>
          </Column>
        </template>
      </el-dropdown>

    </Row>
    <!-- <Row class="h-100b" y="c" x="s">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item,index) in pathArr" :key="index"><Row class="c-white">{{ item.meta?.title }}</Row></el-breadcrumb-item>
      </el-breadcrumb>
      <Elephant
        id="elephant"
        class="m-l-10 pointer"
        :style="elephantStyle"
        :size="elephantRunData.size"
        @click="() => elephantIsRun == false && runTimer(elephantRun, 40)"
      />
    </Row>
    <Row>
      <MenuSearch />
      <div class="m-r-10 m-l-20">{{ userName }}</div>
      <el-button link class="c-white font-18" @click="logout">退出</el-button>
    </Row> -->

  </Row>
</template>
<script setup>
const userStore = useUserStore()
const configStore = useConfigStore()

const logout = () => {
  userStore.logout()
}

const changeLang = async (languag) => {
  configStore.setLanguage(languag.value)
  // userApi.switchLanguage()
}

onMounted(() => {
})

</script>
<style lang="scss">
@use "sass:math";
@use "sass:map";
@import '@/sass/var/index.scss';
.AppNavbar{
  position: relative;
  padding: 0 24px;
  height: 60px;
  box-shadow: 0px 2px 10px 1px rgba(38,73,239,0.06);
  z-index: 1;
  .nickName-box{
    padding: 0 6px;
    transition: all 0.3s;
    border-radius: 10px;
  }
  .nickName-box:hover{
    background: #EBF2FA;
  }
}

.languag-box {
  transition: all 0.1s !important;
  font-size: 16px;
  font-weight: bold;
  .language-title{
    width: 106px;
    height: 40px;
    border-radius: 10px;
    &:hover{
      background-color: #EBF2FA;
    }
  }
  &:hover{
    color: $color-primary;
  }
}

</style>
